<template>
  <aside class="workbench-sidebar">
    <router-link to="/" class="sidebar-brand">
      <img src="/favicon.png" alt="笔芯科研" class="brand-icon" />
      <span class="brand-name">笔芯科研</span>
    </router-link>

    <nav class="sidebar-nav">
      <router-link to="/workbench" class="nav-item" exact active-class="active">
        <i class="bi bi-magic"></i>
        <span>降重降AI</span>
      </router-link>
      <router-link to="/detect" class="nav-item" active-class="active">
        <i class="bi bi-shield-check"></i>
        <span>AIGC检测</span>
      </router-link>
      <router-link to="/ppt" class="nav-item" active-class="active">
        <i class="bi bi-easel"></i>
        <span class="nav-text">答辩PPT</span>
        <span class="nav-badge">免费</span>
      </router-link>
      <router-link to="/literature" class="nav-item" active-class="active">
        <i class="bi bi-journal-bookmark"></i>
        <span>文献检索</span>
      </router-link>
      <router-link to="/word-slim" class="nav-item" active-class="active">
        <i class="bi bi-file-earmark-arrow-down"></i>
        <span>Word瘦身</span>
      </router-link>
      <router-link to="/image-aigc" class="nav-item" active-class="active">
        <i class="bi bi-image"></i>
        <span>图片去AIGC</span>
      </router-link>
    </nav>

    <div class="sidebar-footer">
      <router-link to="/workbench/invite" class="invite-btn" active-class="active">
        <i class="bi bi-gift"></i>
        <span>邀请有奖</span>
      </router-link>

      <div class="quota-card" :class="{ guest: !loggedIn }">
      <template v-if="loggedIn">
        <div class="quota-label">剩余点数</div>
        <div class="quota-value">{{ formattedBalance }}</div>
        <button type="button" class="recharge-btn" @click="$emit('recharge')">去充值</button>
      </template>
      <template v-else>
        <div class="quota-label">账户状态</div>
        <div class="guest-tip">登录后查看剩余点数</div>
        <button type="button" class="recharge-btn" @click="$emit('login')">去登录</button>
      </template>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'WorkbenchSidebar',
  props: {
    loggedIn: {
      type: Boolean,
      default: false
    },
    balance: {
      type: Number,
      default: 0
    }
  },
  computed: {
    formattedBalance() {
      return this.balance.toLocaleString()
    }
  }
}
</script>

<style scoped>
.workbench-sidebar {
  position: sticky;
  top: 0;
  align-self: flex-start;
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  padding: 20px 16px;
  background: #fff;
  border-right: 1px solid #eef0f4;
}

.sidebar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 8px;
  margin-bottom: 28px;
}

.brand-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.brand-name {
  font-size: 18px;
  font-weight: 600;
}

.sidebar-nav {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.sidebar-footer {
  flex-shrink: 0;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.invite-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(90deg, #1976d2, #0288d1);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 14px rgba(25, 118, 210, 0.35);
  transition: opacity 0.2s ease;
}

.invite-btn:hover {
  opacity: 0.92;
  color: #fff;
}

.invite-btn.active {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.35);
}

.invite-btn i {
  font-size: 16px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  color: #374151;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 6px;
  transition: background 0.2s ease, color 0.2s ease;
}

.nav-item i {
  font-size: 18px;
  color: var(--primary);
}

.nav-item.active {
  background: linear-gradient(90deg, rgba(25, 118, 210, 0.12), rgba(25, 118, 210, 0.04));
  color: var(--primary);
  box-shadow: inset 3px 0 0 var(--primary);
}

.nav-text {
  flex: 1;
  min-width: 0;
}

.nav-badge {
  flex-shrink: 0;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
}

.quota-card {
  padding: 18px 16px;
  border-radius: 14px;
  background: linear-gradient(135deg, #f0f7ff 0%, #e3f2fd 100%);
  border: 1px solid rgba(25, 118, 210, 0.15);
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.08);
}

.quota-label {
  font-size: 13px;
  color: var(--text-secondary);
}

.quota-value {
  margin: 8px 0 14px;
  font-size: 32px;
  font-weight: 700;
  color: var(--primary);
  line-height: 1;
}

.recharge-btn {
  width: 100%;
  height: 36px;
  border-radius: 8px;
  background: var(--primary);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;
}

.recharge-btn:hover {
  background: var(--primary-dark);
}

.guest-tip {
  margin: 8px 0 14px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.quota-card.guest {
  background: linear-gradient(135deg, #fafafa 0%, #f3f4f6 100%);
  border-color: #e5e7eb;
}

@media (max-width: 960px) {
  .workbench-sidebar {
    width: 72px;
    padding: 16px 10px;
    align-items: center;
  }

  .sidebar-brand .brand-name,
  .nav-item span,
  .quota-card {
    display: none;
  }

  .invite-btn span {
    display: none;
  }

  .invite-btn {
    width: 48px;
    height: 48px;
    padding: 0;
  }

  .sidebar-brand {
    justify-content: center;
    margin-bottom: 20px;
  }

  .nav-item {
    justify-content: center;
    padding: 12px;
  }
}
</style>
